import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SOCIAL_PLATFORMS } from "@/constants/platforms";
import { v4 as uuid } from "@/lib/uuid";

export function SocialLinksEditor({ links, onChange }) {
  const addLink = () => {
    onChange([...links, { id: uuid(), platform: "instagram", url: "" }]);
  };

  const updateLink = (index, patch) => {
    onChange(links.map((l, i) => (i === index ? { ...l, ...patch } : l)));
  };

  const removeLink = (index) => {
    onChange(links.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-3" data-testid="social-links-editor">
      {links.map((link, i) => (
        <div key={link.id ?? i} className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.03] p-3" data-testid={`social-link-row-${i}`}>
          <Select value={link.platform} onValueChange={(v) => updateLink(i, { platform: v })}>
            <SelectTrigger className="w-40 bg-transparent border-white/15" data-testid={`social-platform-select-${i}`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {SOCIAL_PLATFORMS.map((p) => (
                <SelectItem key={p.value} value={p.value}>
                  <i className={`${p.icon} mr-2`} />{p.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Input
            value={link.url}
            onChange={(e) => updateLink(i, { url: e.target.value })}
            placeholder="https://..."
            className="flex-1 bg-transparent border-white/15"
            data-testid={`social-url-input-${i}`}
          />
          <button onClick={() => removeLink(i)} className="shrink-0 p-2 text-white/40 hover:text-rose-400" data-testid={`remove-social-link-${i}`}>
            <i className="fa-solid fa-trash text-xs" />
          </button>
        </div>
      ))}
      <Button type="button" variant="outline" onClick={addLink} className="border-white/15 border-dashed hover:bg-white/10 w-full" data-testid="add-social-link-button">
        <i className="fa-solid fa-plus mr-2" /> Add Social Link
      </Button>
    </div>
  );
}
